import React, { useState } from "react";
import styles from "./FranchiseForm.module.css";
import { Row, Col, Form, Button } from "react-bootstrap";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import ReCAPTCHA from "react-google-recaptcha";

const locationData = {
  "Madhya Pradesh": {
    Bhopal: ["Bhopal", "Berasia", "Kolar"],
    Indore: ["Indore", "Depalpur", "Mhow"],
    Gwalior: ["Gwalior", "Dabra", "Bhitarwar"],
  },
  "Uttar Pradesh": {
    Lucknow: ["Lucknow", "Malihabad", "Mohanlalganj"],
    Varanasi: ["Varanasi", "Ramnagar", "Chiraigaon"],
    "Kanpur Nagar": ["Kanpur", "Bithoor", "Ghatampur"],
  },
  // ...add all states/districts/cities here
};
// ✅ Inner form component with reCAPTCHA
function FranchiseFormInner() {
  const [validated, setValidated] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (!executeRecaptcha) {
      console.error("Execute recaptcha not yet available");
      return;
    }

    try {
      // Generate token for "franchise_form" action
      const token = await executeRecaptcha("franchise_form");
      console.log("✅ reCAPTCHA token:", token);

      // TODO: Send token + form data to backend for verification
      alert("Form submitted successfully!");
    } catch (err) {
      console.error("❌ reCAPTCHA Error:", err);
    }

    setValidated(true);
  };
  function onChange(value) {
    console.log("Captcha value:", value);
  }

  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");

  const states = Object.keys(locationData);
  const districts = state ? Object.keys(locationData[state]) : [];
  const cities = state && district ? locationData[state][district] : [];

  const [verified, setVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setVerified(true); // reCAPTCHA passed
    } else {
      setVerified(false); // reCAPTCHA cleared or expired
    }
  };
  return (
    <div className={styles.formcontainer}>
      <div className={styles.formbox}>
        <h5
          style={{
            fontFamily: "Inter, sans-serif",
            color: "#07448E",
            fontSize: 18,
            textAlign: "center",
          }}
        >
          Franchise Enquiry Form
        </h5>

        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          style={{ marginTop: 12 }}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Control
                required
                type="text"
                placeholder="Name"
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Control
                required
                type="email"
                placeholder="Email"
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Control
                required
                type="email"
                placeholder="Email"
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Control
                required
                type="tel"
                placeholder="Enter 10-digit Mobile Number"
                pattern="[0-9]{10}"
                maxLength={10}
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontFamily: "sans-serif",
                  fontSize: 14,
                }}
              />
               <Form.Check
                                      required
                                      type="checkbox"
                                      id="whatsappCheck"
                                      label="This is my WhatsApp number"
                                      style={{
                                        marginTop: "8px",
                                        fontFamily: "sans-serif",
                                        fontSize: 13,
                                        color: "#555",
                                      }}
                                    />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Control
                required
                type="text"
                placeholder="Pin Code"
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Select
                required
                value={state}
                onChange={(e) => {
                  setState(e.target.value);
                  setDistrict("");
                  setCity("");
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          {/* District Selector */}
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Select
                required
                value={district}
                onChange={(e) => {
                  setDistrict(e.target.value);
                  setCity("");
                }}
                disabled={!state}
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              >
                <option value="">Select District</option>
                {districts.map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          {/* City Selector */}
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Select
                required
                value={city}
                onChange={(e) => setCity(e.target.value)}
                disabled={!district}
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "1px solid #767676",
                  borderRadius: 0,
                  fontSize: 14,
                }}
              >
                <option value="">Select City</option>
                {cities.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 20,
            }}
          >
            <ReCAPTCHA
              sitekey="6Lcv2aMrAAAAABFz2tVGCJQJX98zkXGnBV9zzg8O"
              onChange={handleCaptchaChange}
            />
          </div>
          {}{" "}
          <Button
            type="submit"
            className="mx-auto d-block"
            style={{
              border: "1px solid #66d6ff",
              backgroundColor: "transparent",
              color: "#66d6ff",
              fontFamily: "Inter",
              width: 120,
            }}
            disabled={!verified} // disable until captcha is done
          >
            Submit
          </Button>
        </Form>
        <br />
      </div>
    </div>
  );
}

// ✅ Wrap in GoogleReCaptchaProvider
export default function FranchiseForm() {
  console.log("recaptch", process.env.REACT_APP_USER_CAPTCHA_SITE_KEY);
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={"6Lcv2aMrAAAAABFz2tVGCJQJX98zkXGnBV9zzg8O"}
    >
      <FranchiseFormInner />
    </GoogleReCaptchaProvider>
  );
}
